import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const getCurrent = (params) =>
  requestsTemplates.get(mainPath, "/getCurrentUser/",params);